import cookies from 'js-cookie';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled from 'styled-components';
import url from 'url';

/* This pixel allows us to sew sessions together in the data lake cross domain. */
export default class TrackingPixel extends Component {
    static propTypes = {
        /**
         * For testing, since JSDOM doesn't allow proper mocking
         * of window.location.
         */
        __url: PropTypes.string,
    };

    state = {
        mounted: false,
    };

    componentDidMount() {
        this.setState({ mounted: true });
    }

    render() {
        if (
            this.state.mounted
            && !this.isPercy()
            && this.isWhiteLabelDomain()
        ) {
            const bsid = cookies.get('bsid');
            const trackingId = cookies.get('firstTimeVisitor');
            const trackingPixelUrl = `https://www.zocdoc.com/tracking/v1/pixel?token=${bsid}||${trackingId}`;

            return (
                <Pixel
                    alt=""
                    data-test="tracking-pixel"
                    src={trackingPixelUrl}
                />
            );
        }

        return null;
    }

    isPercy() {
        return global.theme;
    }

    isWhiteLabelDomain() {
        let hostname;

        if (this.props.__url) {
            ({ hostname } = url.parse(this.props.__url));
        } else {
            ({ location: { hostname } } = window);
        }

        return (
            !hostname.endsWith('zocdoc.com')
            && !hostname.endsWith('zocdoccloud.net')
            && !hostname.endsWith('localhost')
        );
    }
}

const Pixel = styled.img`
    border: 0;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
`;
